/**
 * Created by mongoose on 8/11/17.
 */
import { BASE_URL } from "../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../CRUD/utils";

const ModuleDefinition = {
  name: "Selenta Prices Feed",
  entityName: "priceFeed",
  restConfig: {
    baseURL: `${BASE_URL}`,
    fetch: {
      url: () => `api/properties/reports/prices/selenta`,
      method: "get",
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "Traducciones",
    widget: "translations",
    entityProperty: "translations",
  },
  fields: {
    list: [],
    form: [
      {
        fieldName: "startDate",
        displayName: "Booking window start date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
      },
      {
        fieldName: "endDate",
        displayName: "Booking window end date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
      },
    ],
  },
  validation: {
    startDate: {
      type: "Date",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },

    endDate: {
      type: "Date",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
